import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-z', 'LetterZ', [["path",{"d":"M8 7h7.5L8 17h7.5","key":"svg-0"}]]);